import { createConsumer } from '@rails/actioncable'
import { useAuthStore } from '../stores/authStore'

let consumer = null

// Returns a singleton ActionCable consumer for the signed-in user.
//
// Phase 1.5: auth is Devise session cookies, not JWT. The browser sends the
// session cookie automatically on the WebSocket handshake, and
// `ApplicationCable::Connection` identifies the user from `env['warden']` —
// so there's no token to pass on the URL. We only gate on whether the user is
// authenticated (returning null when logged out, which callers handle).
export function getConsumer() {
  if (!useAuthStore.getState().isAuthenticated()) {
    consumer?.disconnect()
    consumer = null
    return null
  }

  if (!consumer) {
    consumer = createConsumer('/cable')
  }
  return consumer
}

export function disconnectConsumer() {
  consumer?.disconnect()
  consumer = null
}
